<template>
  <div>
    <label
      v-if="label"
      class="block text-sm mb-1"
      :class="{ 'text-primary!': hasError }"
    >
      {{ label }}
      <span v-if="required" class="text-red-500">*</span>
    </label>

    <textarea
      :id="id"
      v-model="value"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :readonly="readonly"
      :autocomplete="autocomplete"
      class="hover-scroll text-[15px] placeholder:text-sm block w-full p-3.5 bg-gray-100/75 rounded-lg focus:outline-2 outline-transparent focus:outline-primary-blue transition-all duration-300"
      :class="{
        'border-gray-300': !hasError,
        'border-red-500': hasError,
        'bg-gray-100 cursor-not-allowed': disabled || readonly,
      }"
      rows="4"
    ></textarea>

    <p v-if="hasError && errorMessage" class="mt-1 text-sm text-red-600">
      {{ errorMessage }}
    </p>
    <p v-if="hint && !hasError" class="mt-1 text-sm">
      {{ hint }}
    </p>
  </div>
</template>

<script setup lang="ts">
const value = defineModel<string | number>({ default: "" });

interface Props {
  id?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  autocomplete?: string;
  hasError?: boolean;
  errorMessage?: string;
  hint?: string;
}

withDefaults(defineProps<Props>(), {
  id: () => `input-${Math.random().toString(36).slice(2, 9)}`,
  label: "",
  placeholder: "",
  required: false,
  disabled: false,
  readonly: false,
  autocomplete: "off",
  hasError: false,
  errorMessage: "",
  hint: "",
});
</script>
